module.exports = __webpack_public_path__ + "static/media/gift-exchanges-alt.127052f2.svg";